// Import Packages
import React, {useState} from "react";

// Import Material UI
import SquareBrackets from '../../../../../../../assets/icons/JsonPreviewIcons/SquareBrackets';
import CurlyBrackets from '../../../../../../../assets/icons/JsonPreviewIcons/CurlyBrackets';
import TextFormatIcon from '@material-ui/icons/TextFormat';
import LooksOneIcon from '@material-ui/icons/LooksOne';
import Button from '@material-ui/core/Button';
import EditAttributesIcon from '@material-ui/icons/EditAttributes';
import ListIcon from '@material-ui/icons/List';
import ViewComfyIcon from '@material-ui/icons/ViewComfy';
import Tooltip from "@material-ui/core/Tooltip";

// Import Pages
import ObjectField from '../objectField/ObjectField';

// Import CSS
import '../objectField/objectField.css';

const ArrayField = ({
                        disabledFields,
                        data,
                        keyPath,
                        selectField,
                        names,
                        hasParent,
                        fp_details,
                        disableInputs,
                        foundFields,
                        searchText
                    }) => {
    const [collapse, setCollapse] = useState(false);
    const [hover, setHover] = useState(false);

    const toggleHover = () => {
        setHover(!hover)
    }

    return <>
        <div onClick={() => setCollapse(!collapse)} onMouseEnter={toggleHover} onMouseLeave={toggleHover}
             className={`collapse-button ${hover ? 'hover' : ''}`}>
            <button className="button"><span className={collapse ? 'plus' : 'minus'}>{collapse ? '+' : '-'}</span>
            </button>
        </div>
        <span>
            <div className={`left10 display-${collapse ? 'none' : 'block'}`}>
                {
                    data.map((value, index) => {
                        let newKeyPath = keyPath;
                        newKeyPath += `[${index}]`;
                        // let newKeyPath = Array.from(keyPath);
                        // newKeyPath.push(index);
                        let type = typeof value;
                        if (Array.isArray(value)) {
                            if (value.length > 0) {
                                return (
                                    <div>
                                        <Tooltip title={index} placement="right-end">
                                            <span>
                                                <Button
                                                    disabled={true}
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    startIcon={<ListIcon/>}
                                                >
                                                    {index}
                                                </Button>
                                            </span>
                                        </Tooltip>
                                        <ArrayField data={value} keyPath={newKeyPath}
                                                    hasParent={true} foundFields={foundFields} searchText={searchText}
                                                    names={names}
                                                    selectField={selectField}
                                                    fp_details={fp_details}
                                                    disabledFields={disabledFields}
                                                    disableInputs={disableInputs}
                                        />
                                    </div>
                                )
                            } else {
                                return (
                                    <div className="padding-empty-array">
                                        <Tooltip title={index} placement="right-end">
                                            <span>
                                                <Button
                                                    disabled={true}
                                                    variant="contained"
                                                    color="primary"
                                                    size="small"
                                                    startIcon={<ListIcon/>}
                                                >
                                                    {index}
                                                </Button>
                                            </span>
                                        </Tooltip>
                                    </div>
                                )
                            }

                        } else if (type === 'object') {
                            return (
                                <div className="left10 db">
                                    <Tooltip title={index} placement="right-end">
                                        <span>
                                            <Button
                                                disabled={true}
                                                variant="contained"
                                                color="primary"
                                                size="small"
                                                startIcon={<ViewComfyIcon/>}
                                            >
                                                {index}
                                            </Button>
                                        </span>
                                    </Tooltip>
                                    <ObjectField disabledFields={disabledFields} data={value} names={names}
                                                 path={newKeyPath} hasParent={true} root={true} fp_details={fp_details}
                                                 disableInputs={disableInputs} searchText={searchText}
                                                 foundFields={foundFields} selectField={selectField}/>
                                </div>
                            )
                        } else {
                            return (
                                <div className="padding-top-5">
                                    <Tooltip title={index} placement="right-end">
                                        <Button
                                            onClick={() => selectField(index, type, newKeyPath)}
                                            variant="contained"
                                            color="primary"
                                            size="small"
                                            startIcon={type === 'string' ? <TextFormatIcon/> : (type === 'number' ?
                                                <LooksOneIcon/> : <EditAttributesIcon/>)}
                                        >
                                            {index}
                                        </Button>
                                    </Tooltip>
                                </div>
                            )
                        }
                    })
                }
            </div>
        </span>
    </>
}

export default ArrayField;
